import { OperationsMetadata } from './operationsMetadata.js';
import { NavigationDecision } from './navigationDecision.js';
import { JsonObject } from '../app/json/jsonValue.js';

export class MergeResult {
    appFile: string;
    componentHtml: JsonObject;
    operations: OperationsMetadata | null;
    dynamicData: JsonObject;
    dynamicView: JsonObject;
    dynamicAction: JsonObject;
    // Dynamic client-data RAW island set, values are JsonObject. Straight 1:1 alias of
    // DynamicResults.dynamicClientDataResults (see that field for the intentionally double-purposed
    // server-produce vs client-re-emit key derivation). Holds the RAW set a browser handler filters
    // client-side; the endpoint reads it from here (single path, full merge context). Empty unless a
    // component is bound in dynamicclientdata.json. Not serialized into the api-json envelope in P2A
    // (that is P2B hydration).
    dynamicClientData: JsonObject;
    // Dynamic client CONSUMER results keyed by "ComponentName_ClientDataKey", values are JsonObject. Holds the
    // FILTERED output the IClient consumer produced from the delivered raw island (the client mirror of the
    // server DynamicData). Populated only on the client tier (clientMode round-trip), so it is empty on a
    // server merge — the counterpart to dynamicClientData (raw preparer set) that lets the round-trip prove
    // all engines' consumers produce identical output.
    dynamicClient: JsonObject;
    resolvedAppSite: string;
    resolvedAppView: string;
    // The ordered list of IAppSite-handler navigation decisions taken during applyDynamicAppSiteHandlers
    // (one entry per handler invocation, change or no-op). resolvedAppSite/resolvedAppView hold the FINAL
    // pair; this preserves every intermediate hop and its reason. Empty when no AppSite handlers ran.
    navigationTrace: NavigationDecision[];

    constructor(appFile: string = '', componentHtml: JsonObject = new JsonObject(), operations: OperationsMetadata | null = null, dynamicData: JsonObject = new JsonObject(), dynamicView: JsonObject = new JsonObject(), dynamicAction: JsonObject = new JsonObject()) {
        this.appFile = appFile;
        this.componentHtml = componentHtml;
        this.operations = operations;
        this.dynamicData = dynamicData;
        this.dynamicView = dynamicView;
        this.dynamicAction = dynamicAction;
        this.dynamicClientData = new JsonObject();
        this.dynamicClient = new JsonObject();
        this.resolvedAppSite = '';
        this.resolvedAppView = '';
        this.navigationTrace = [];
    }
}
